import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button
} from '@mui/material';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getClients} from '../services/api';
import ImpEtiquetasModal from './impetiquetasmodal';

const ImpEtiquetas = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    getClients()
      .then(res => {
        setClients(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleSearchChange = e => setSearchTerm(e.target.value);

  

  const handlePrintClick = client => {
    setSelectedClient(client);
    setModalOpen(true);
  };

  // só os que já têm ficheiro
  const filtered = clients
    .filter(c => c.excel_file)
    .filter(c => {
      const s = searchTerm.toLowerCase();
      return (
        c.nome2?.toLowerCase().includes(s) ||
        c.name?.toLowerCase().includes(s) ||
        c.email?.toLowerCase().includes(s)
      );
    });

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Gerar Etiquetas</Typography>

      <TextField
        fullWidth
        placeholder="Procurar por cliente"
        variant="outlined"
        value={searchTerm}
        onChange={handleSearchChange}
        sx={{ mb: 2 }}
      />

      <DataTable
        value={filtered}
        loading={loading}
        paginator rows={10}
        dataKey="id"
      >
        <Column field="nome2" header="Abreviatura" sortable />
        <Column field="name" header="Nome" sortable />
        <Column field="email" header="Email" sortable />
        <Column
          header="Ações"
          body={client => (
            <Grid container spacing={1}>
              
              <Grid item>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handlePrintClick(client)}
                >
                  Imprimir Etiquetas
                </Button>
              </Grid>
            </Grid>
          )}
        />
      </DataTable>

      <ImpEtiquetasModal
        open={modalOpen}
        client={selectedClient}
        onClose={() => setModalOpen(false)}
      />
    </Box>
  );
};

export default ImpEtiquetas;
